import config from '../../config'
import fetch from '../../lib/wrappedFetch'
import productsService from '../../services/productsService'

class ProductsController {
  searchProducts = productsService.searchProducts
  fetchProduct = productsService.fetchProduct
  fetchProductGroupProducts = productsService.fetchProductGroupProducts
  fetchProductByEan = productsService.fetchProductByEan
  fetchProductCatalogues = productsService.fetchProductCatalogues
}

export default new ProductsController()
 


// WEBPACK FOOTER //
// ../src/controllers/productsController/productsController.js